import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import {
  Box,
  TextField,
  Button,
  Typography,
  Grid2,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LogoIcon from "../../assets/images/LogoIcon.svg";
import LogoText from "../../assets/images/LogoText.svg";
import mail from "../../assets/images/email.svg";
import passwordimg from "../../assets/images/passwordimg.svg";
import googleIcon from "../../assets/images/google-icon.svg";
import facebookIcon from "../../assets/images/facebook.svg";
import rightArrow from "../../assets/images/right.svg";
import emailPhone from "../../assets/images/EmailPhone.svg";
import mobile from '../../assets/images/mobile-alt.svg';

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import Snackbars from "../../utils/Snackbars";
import useRequestsWOAccessToken from "../../utils/useRequestsWOAccessToken";
import {
  loadingToggleAction,
  loginAction,
} from "../../store/actions/AuthActions";
import Password from "../../assets/images//password.png";
import HidePassword from "../../assets/images/hidePassword.png";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { getRequestWOAccessToken, postRequestWOAccessToken } =
    useRequestsWOAccessToken();

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const [showPassword, setShowPassword] = useState(false);

  // const handleSignIn = () => {
  //     navigate('/dashboard'); // Replace '/dashboard' with your desired route
  // };
  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: "",
      // password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Mobile Number is required")
        .test(
          "email-or-phone",
          "Must be a valid 10-digit phone number",
          function (value) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const phoneRegex = /^\d{10}$/;
            return emailRegex.test(value) || phoneRegex.test(value);
          }
        ),
      // password: Yup.string().required("Login Password is required"),
    }),
    onSubmit: async (values) => {
      // e.preventDefault();
      try {
        let submit1 = document.getElementById("submit1");
        submit1.disabled = true;
        submit1.textContent = "Processing...";

        const jsonpar = JSON.stringify({
          email: values.email,
          // password: values.password,
        });
        const res = await postRequestWOAccessToken("auth/login", jsonpar);
        if (res && res.code === 200) {
          // if (res.data.is_email_verified === "Yes") {
            // if (res.data.is_phone_verified === "Yes") {
            //   let tokenDetails = {
            //     guestMode: false,
            //     email: res.data.email,
            //     displayName: `${res.data.first_name} ${res.data.last_name}`,
            //     idToken: res.data.accesstoken,
            //     registered: true,
            //     refreshToken: res.data.refreshtoken,
            //     expiresIn: 3600,
            //   };
            //   dispatch(loadingToggleAction(true));

            //   const urlParams = new URLSearchParams(location.search);
            //   const redirectTo = urlParams.get("redirect");
            //   const eventId = urlParams.get("e_id");
            //   const dayPass = urlParams.get("day_pass");

            //   let redirectPath = "/dashboard";

            //   if (redirectTo && eventId) {
            //     if (redirectTo === "book-ticket") {
            //       redirectPath = `/dashboard/events-details/book-ticket/${eventId}`;
            //       if (dayPass) {
            //         redirectPath += `?day_pass=${dayPass}`;
            //       }
            //     } else if (redirectTo === "resell-market") {
            //       redirectPath = `/resell-market/ticket-list/${eventId}`;
            //     }
            //   }

            //   dispatch(
            //     loginAction(tokenDetails, () => navigate(redirectPath), {
            //       code: 200,
            //       status: "success",
            //       message: "Login successful !",
            //     })
            //   );
            // } else {
              const params = location.search ? location.search : "";
              navigate(`/verify-phone${params}`, {
                state: { email: res.data.email, phone: res.data.phone, message: "Login successful !" },
              });
            // }
          // } else {
          //   const params = location.search ? location.search : "";
          //   navigate(`/verify-user${params}`, {
          //     state: { email: res.data.email, phone: res.data.phone },
          //   });
          // }
        } else {
          setAlertData({ variant: "error", message: res.message });
        }
      } catch (error) {
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: "error",
          message: "An error occurred while updating the password.",
        }));
      } finally {
        resetAlertData();

        let submit1 = document.getElementById("submit1");
        submit1.disabled = false;
        submit1.textContent = "Sign In";
      }
    },
  });

  const handleGoogleLogin = async () => {
    try {
      const response = await getRequestWOAccessToken(`auth/google-auth`);
      if (response.code === 200 && response.data) {
        // Add redirect parameters to Google auth URL
        const urlParams = new URLSearchParams(location.search);
        const redirectParams = urlParams.toString();
        const authUrl = redirectParams
          ? `${response.data}&state=${encodeURIComponent(redirectParams)}`
          : response.data;
        window.open(authUrl, "_self");
      } else {
        setAlertData({
          variant: "error",
          message: "Failed to fetch login URL!",
        });
      }
    } catch (error) {
      setAlertData({ variant: "error", message: "Something went wrong!" });
    }
  };
  const handleFacebookLogin = async () => {
    try {
      const response = await getRequestWOAccessToken(`auth/facebook-auth`);
      if (response.code === 200 && response.data) {
        window.open(response.data, "_self");
      } else {
        setAlertData({
          variant: "error",
          message: "Failed to fetch login URL!",
        });
      }
    } catch (error) {
      setAlertData({ variant: "error", message: "Something went wrong!" });
    }
  };

  const guestLogin = async () => {
    try {
      const response = await getRequestWOAccessToken(`auth/guest-login`);
      if (response.code === 200 && response.data) {
        let tokenDetails = {
          guestMode: true,
          idToken: response.data.accesstoken,
          refreshToken: response.data.refreshtoken,
          expiresIn: 3600,
        };
        dispatch(loadingToggleAction(true));

        // Check for redirect parameters for guest login
        const urlParams = new URLSearchParams(location.search);
        const redirectTo = urlParams.get("redirect");
        const eventId = urlParams.get("e_id");

        let redirectPath = "/dashboard";

        if (redirectTo && eventId) {
          if (redirectTo === "book-ticket") {
            redirectPath = `/dashboard/events-details/book-ticket/${eventId}`;
          } else if (redirectTo === "resell-market") {
            redirectPath = `/resell-market/ticket-list/${eventId}`;
          }
        }

        dispatch(
          loginAction(tokenDetails, () => navigate(redirectPath), {
            code: 200,
            status: "success",
            message: "",
          })
        );
      } else {
        setAlertData({ variant: "error", message: "Failed to login as guest" });
      }
    } catch (error) {
      setAlertData({ variant: "error", message: "Something went wrong!" });
    }
  };

  const handleSignUp = (e) => {
    e.preventDefault();
    const params = location.search ? location.search : "";
    navigate(`/signup${params}`);
  };

  React.useEffect(() => {
    // localStorage.removeItem('userDetails');
    if (location.state && typeof location.state.message !== "undefined") {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
      if(location.state.redirect) {
        const redirectTo = location.state.redirect;
        const eventId = location.state.e_id;
        const dayPass = location.state.day_pass;

        let redirectPath = "/login";

        if (redirectTo && eventId) {
          redirectPath += `?redirect=${redirectTo}&e_id=${eventId}`;
          if (dayPass) {
            redirectPath += `&day_pass=${dayPass}`;
          }
        }
        navigate(redirectPath);
      }
      else if(location.search) {
        const params = location.search;
        navigate(`/login${params}`);
      }
      else {
        navigate(location.pathname, { replace: true });
      }
    }
  }, []);

  return (
    <Grid2>
      <Link className="skip" onClick={guestLogin}>
        Skip <img src={rightArrow} alt="" />
      </Link>
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "calc(98vh - 33px)",
        }}
      >
        <Box
          sx={{
            width: 500,
            padding: 4,
            borderRadius: 2,
            backgroundColor: "#fff",
            textAlign: "center",
          }}
        >
          <Grid2 className="fullLogo">
            <div className="centerLogo">
              <img
                src={LogoIcon}
                alt="Logo"
                width={80}
                style={{ marginBottom: "10px" }}
              />
            </div>
            <div className="centerLogo">
              <img src={LogoText} alt="Logo" width={180} />
            </div>
          </Grid2>
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            className="signin-title"
          >
            Sign In
          </Typography>
          <Typography variant="body2" sx={{ textAlign: 'center', mt: 1, mb: 1, color: 'text.secondary' }}>
            If you don't have an account yet, we'll create one for you
          </Typography>
          <form className="loginForm">
            <div className="position-relative">
              <img
                src={mobile}
                alt="Logo"
                width={24}
                className="textboxLefticon"
              />
              <TextField
                variant="outlined"
                fullWidth
                margin="normal"
                placeholder="Mobile Number"
                autoComplete="off"
                name="email"
                type="text"
                className={`form-control ${
                  validation1.touched.email && validation1.errors.email
                    ? "is-invalid"
                    : ""
                }`}
                value={validation1.values.email || ""}
                // onChange={(e) => setEmail(e.target.value)}
                onChange={validation1.handleChange}
                invalid={
                  validation1.touched.email && validation1.errors.email
                    ? true
                    : false
                }
              />
              {validation1.touched.email && validation1.errors.email ? (
                <div className="invalid-feedback">
                  {validation1.errors.email}
                </div>
              ) : null}
            </div>
            {/* <div className="position-relative password-field">
              <img
                src={passwordimg}
                alt="Logo"
                width={24}
                className="textboxLefticon"
              />
              <TextField
                variant="outlined"
                fullWidth
                margin="normal"
                placeholder="Password"
                required
                name="password"
                type={showPassword ? "text" : "password"}
                className={`password-textbox form-control ${
                  validation1.touched.password && validation1.errors.password
                    ? "is-invalid"
                    : ""
                }`}
                onChange={validation1.handleChange}
                value={validation1.values.password || ""}
                invalid={
                  validation1.touched.password && validation1.errors.password
                    ? true
                    : false
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                        style={{ marginRight: "0px" }}
                      >
                        <img
                          className="password-hide-show"
                          src={showPassword ? Password : HidePassword}
                          alt="Toggle Password"
                          width={24}
                          height={24}
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                // style={{borderColor:'red'}}
              />
              {validation1.touched.password && validation1.errors.password ? (
                <div type="invalid" className="invalid-feedback">
                  {validation1.errors.password}
                </div>
              ) : null}
            </div> */}
            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{ marginTop: 2 }}
              type="submit"
              id="submit1"
              className="btn-common btn bg-primary text-white btn-block"
              onClick={(e) => {
                e.preventDefault();
                validation1.handleSubmit();
                return false;
              }}
            >
              {"Sign In"}
            </Button>
          </form>
          {/* <Typography className="or">OR</Typography>
          <div className="">
            <Button
              className="btn-common-border"
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ marginTop: 2 }}
              onClick={handleGoogleLogin}
            >
              <img
                className="social-login-icon"
                src={googleIcon}
                alt=""
                width={24}
              />
              Sign up with Google
            </Button>
            <Button
              className="btn-common-border"
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ marginTop: 2 }}
              onClick={handleFacebookLogin}
            >
              <img
                className="social-login-icon"
                src={facebookIcon}
                alt=""
                width={24}
              />
              Login with Facebook
            </Button>
          </div> */}
          {/* <div className="position-relative"> 
            <Typography className="dont" sx={{ marginTop: "30px" }}>
              Don't have an account? <Link to="#" onClick={handleSignUp}>Sign up</Link>
            </Typography> */}
            {/* <Typography className="dont">
              <Link className="mt-2 float-end mb-4" to="/forgot-password">
                Forget Password?
              </Link>
            </Typography> */}
          {/* </div> */}
        </Box>
      </Box>
      {/* <Typography className="dont">
        Don't have an account? <Link to="#" onClick={handleSignUp}>Sign up</Link>
      </Typography>
      <Typography className="dont">
        <Link className="mt-2 float-end mb-4" to="/forgot-password">
          Forget Password?
        </Link>
      </Typography> */}
    </Grid2>
  );
};
export default Login;
